
import { Vue, Component, Prop } from "vue-property-decorator";

import InformationWrapper from "@/components/inforationCards/InformationWrapperNew.vue";
import InformationCard from "@/components/inforationCards/InformationCardNew.vue";
import InformationEmptyAboutCard from "@/components/inforationCards/InformationEmptyAboutCardNew.vue";
import PageHeadIcon from "@/components/page/PageHeadIconNew.vue";
import FormattedDescription from "@/components/common/FormattedDescription.vue";
import ItemChip from "@/components/common/ItemChip.vue";
import InformationSection from "@/components/inforationCards/InformationSection.vue";
import ImageSample from "@/components/common/ImageSample.vue";
import Slider from "@/components/common/SliderNew.vue";
import VideoPlayer from "@/components/common/VideoPlayerNew.vue";
import DownloadResume from "@/components/profile/DownloadResume.vue";
import ExperienceCard from "@/components/profile/ExperienceCardNew.vue";
import EducationCard from "@/components/profile/EducationCardNew.vue";
import CertificationCard from "@/components/profile/CertificationCardNew.vue";
import CardPagination from "@/components/card/CardPagination.vue";
import UIButton from "@/components/button/ui-button.vue";
import UiButton from "@/components/button/ui-button-message.vue";
import ChipsWithMore from "@/components/common/ChipsWithMoreResource.vue";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
import NewTabLink from "@/components/common/NewTabLink.vue";
import ItemChipsWithMore from "@/components/common/ItemChipsWithMoreNew.vue";
import CardBodyItem from "@/components/card/CardBodyItemNew.vue";
import CollapsibleDescription from "@/components/common/CollapsibleDescriptionNew.vue";
import EmptyListImageDocuments from "@/components/icons/emptyListImages/EmptyListImageContractorDocuments.vue";
import EmptyResourceInformationPlaceholder from "@/components/common/EmptyResourceInformationPlaceholderNew.vue";
import ResourceDataTable from "@/components/contractors/ResourceDataTableNew.vue";
import { NO_INFORMATION } from "@/data/placeholders";
import {
  getSkillsForChips,
  getLanguagesForChips,
  getIndustriesForChips,
} from "@/helpers/cardInfoHelperFunctions/chipDataHelpers";
import ManagementAddContractorInfo from "@/components/contractors/ManagementAddContractorInfoNew.vue";
import AddResumeModal from "@/components/contractors/AddResumeModal.vue";
import {
  Experience_Skill,
  User_Education,
  User_Certification,
  User_Experience,
  User_Profile,
  User_Profile_By_Management,
  Resource_Information_Card,
} from "@/generated/graphql";
import GET_USER_PROFILE from "@/apollo/profile/profileDetails/management/GetUserProfile.gql";
import ItemChipsData from "@/entities/ItemChipsData";
import CrossIcon from "@/components/icons/CrossIconNew.vue";
import CrossIconHover from "@/components/icons/CrossIconHover.vue";
import { Maybe } from "node_modules/graphql/jsutils/Maybe";
import getStateProvinceSelectTitle from "@/helpers/locations/getStateProvinceSelectTitle";
import { Contractor } from "@/interface";
import ChipWithLinkData from "@/types/ChipWithLinkData";
import REMOVE_EDUCATION from "@/apollo/profile/educations/RemoveEducation.gql";
import { NOTIFICATION } from "@/entities/Events";
import Message from "@/data/notificationsMessages";
import DownloadIcon from "@/components/icons/DownloadIconNew.vue";
import PaginationConfig from "@/entities/PaginationConfig";
import paginationConfig from "@/data/paginationConfig";
import GET_PROFILE_RATES from "@/apollo/profile/profileDetails/management/GetUserProfile.gql";
interface ManagementAddedInfoMode {
  skills: boolean;
  softSkills: boolean;
  industries: boolean;
  languages: boolean;
  workSamples: boolean;
  experience: boolean;
  education: boolean;
  certification: boolean;
  rating: boolean;
  contactInfo: boolean;
  website: boolean;
  company: boolean;
  jobTitle: boolean;
  rate: boolean;
  country: boolean;
  region: boolean;
  city: boolean;
  resume: boolean;
}

@Component({
  components: {
    InformationCard,
    InformationWrapper,
    NewTabLink,
    DownloadIcon,
    PageHeadIcon,
    FormattedDescription,
    ItemChip,
    InformationSection,
    ImageSample,
    CrossIcon,
    CrossIconHover,
    Slider,
    ChipsWithMore,
    VideoPlayer,
    DownloadResume,
    ExperienceCard,
    EducationCard,
    CertificationCard,
    ManagementAddContractorInfo,
    LoadingOverlay,
    ItemChipsWithMore,
    UiButton,
    CardBodyItem,
    CollapsibleDescription,
    EmptyListImageDocuments,
    InformationEmptyAboutCard,
    EmptyResourceInformationPlaceholder,
    ResourceDataTable,
    AddResumeModal,
    CardPagination,
    UIButton,
  },
  apollo: {
    userProfile: {
      query: GET_USER_PROFILE,
      variables() {
        return {
          id: this.contractorUserId,
        };
      },
      update(data) {
        const profile = data.user_profile_by_pk;
        if (!profile) {
          this.showDiscalimer = true;
          return null;
        }
        this.adminWork = profile.work_samples;
        return profile;
      },
    },
  },
})
export default class ContractorDetailedInformation extends Vue {
  // @Prop({ type: Array, default: () => [] })
  // readonly experiences!: Experience_Skill[];
  @Prop({ type: Array, default: () => [] })
  readonly educations!: User_Education[];
  @Prop({ type: Array, default: () => [] })
  readonly certifications!: User_Certification[];
  @Prop({ type: Object, required: true }) readonly profile!: User_Profile;
  @Prop({ type: Array, default: () => [] })
  readonly experiences!: User_Experience[];
  @Prop({ type: String, required: true }) readonly contractorId!: string;
  @Prop({ type: String, required: true }) readonly contractorUserId!: string;
  @Prop({ type: String, required: true }) readonly hasSource!: string;
  @Prop({ type: Array, default: () => [] })
  readonly resourceCard!: Resource_Information_Card[];
  @Prop({ type: String, required: true }) readonly currentUserId!: string;
  @Prop({ type: Boolean, required: false, default: true })
  readonly isAccessGranted!: boolean;

  contractor: Contractor[] = [];
  noInfo = NO_INFORMATION;
  showResume: boolean = false;
  paginationConfig: PaginationConfig = { ...paginationConfig };
  managementAddedInfoMode: ManagementAddedInfoMode = {
    skills: false,
    softSkills: false,
    industries: false,
    languages: false,
    workSamples: false,
    experience: false,
    education: false,
    certification: false,
    rating: false,
    contactInfo: false,
    website: false,
    company: false,
    jobTitle: false,
    rate: false,
    country: false,
    region: false,
    city: false,
    resume: false,
  };
  managementAddedInfoModeInit: ManagementAddedInfoMode = {
    skills: false,
    softSkills: false,
    industries: false,
    languages: false,
    workSamples: false,
    experience: false,
    education: false,
    certification: false,
    rating: false,
    contactInfo: false,
    website: false,
    company: false,
    jobTitle: false,
    rate: false,
    country: false,
    region: false,
    city: false,
    resume: false,
  };
  showManagementAddContractorInfoModal: boolean = false;
  userProfile: any = null;
  adminWork: [] = [];
  processing: boolean = false;
  showDiscalimer: boolean = false;
  isHovered: boolean = false;

  get contractorId_(): Object {
    return {
      contractor_id: this.contractorId,
    };
  }

  get secondaryItemClasses(): Record<string, boolean> {
    return {
      "py-4 border-primary-color": true,
    };
  }

  get getRateLength(): number | string {
    let length = 0;
    if (this.contractorRates.length) {
      length += 1;
    }
    if (this.contractorRatesByManagement.length) {
      length += 1;
    }
    return length > 0 ? `(${length})` : '';
  }

  get stateProvinceLabel(): string {
    const country = this.userProfile?.country;
    return getStateProvinceSelectTitle([{ id: country!, name: country! }]);
  }

  get resourceCardStyles(): Object {
    return {
      [this.cardStyles]: this.resourceCard.length > 0,
    };
  }

  get experienceStyles(): Object {
    return {
      [this.cardStyles]: this.experiences.length > 0,
    };
  }

  get educationStyles(): Object {
    return "px-6";
  }

  get certificationStyles(): Object {
    return {
      [this.cardStyles]: this.certifications.length > 0,
    };
  }
  get containerStyles(): string {
    return "px-6";
  }
  get cardStyles(): string {
    return "pb-4";
  }

  // get experiencesByManagement(): User_Experience[] {
  //       if (!this.experiences) {
  //           return undefined;
  //       }
  //       const experiences = this.experiences.reduce(function (filtered: User_Experience[], experience: User_Experience) {
  //           if (experience.added_by_id) {
  //               filtered.push(experience);
  //           }
  //           return filtered
  //       }, []);
  //       return experiences;
  //   }

  //   get educationsByManagement(): User_Education[] {
  //       if (!this.educations) {
  //           return undefined;
  //       }
  //       const educations = this.educations.reduce(function (filtered: User_Education[], education: User_Education) {
  //           if (education.added_by_id) {
  //               filtered.push(education);
  //           }
  //           return filtered
  //       }, []);
  //       return educations;
  //   }

  //   get certificationsByManagement(): User_Certification[] {
  //       if (!this.certifications) {
  //           return undefined;
  //       }
  //       const certifications = this.certifications.reduce(function (filtered: User_Certification[], certification: User_Certification) {
  //           if (certification.added_by_id) {
  //               filtered.push(certification);
  //           }
  //           return filtered
  //       }, []);
  //       return certifications;
  //   }


  get workSamples() {
    return this.userProfile?.work_samples?.length > 0 ? this.userProfile.work_samples : null;
  }

  get skills(): ItemChipsData[] {
    if (!this.userProfile?.skills) {
      return [];
    }
    const skills = this.userProfile.skills.reduce(function (filtered, userSkill) {
      if (!userSkill.added_by_id) {
        filtered.push(userSkill.skill);
      }
      return filtered;
    }, []);
    return getSkillsForChips(skills);
  }

  get skills2(): ChipWithLinkData[] {
    if (!this.userProfile?.skills) {
      return [];
    }
    // Use a Set to keep track of unique skill IDs
    const uniqueSkillIds = new Set();

    const skills = this.userProfile.skills.reduce((filtered, userSkill) => {
      // Prepare the chipWithLinkData based on the userSkill
      let chipWithLinkData: ChipWithLinkData = {
        variant: userSkill.added_by_id ? "green" : "blue",
        chipLink: {},
        chipData: {
          id: userSkill.skill.id.toString(),
          name: userSkill.skill.name,
        },
        avatar: "",
        chipText: "",
      };

      if (!uniqueSkillIds.has(chipWithLinkData.chipData.id)) {
        // If not, add it to the Set and to the filtered array
        uniqueSkillIds.add(chipWithLinkData.chipData.id);
        filtered.push(chipWithLinkData);
      }

      return filtered;
    }, []);

    skills.sort((a, b) => a.variant.localeCompare(b.variant));
    return skills;
  }

  get softSkills2(): ChipWithLinkData[] {
    if (!this.userProfile?.user_soft_skills) {
      return [];
    }
    // Use a Set to keep track of unique soft skill IDs
    const uniqueSoftSkillIds = new Set();

    const softSkills = this.userProfile.user_soft_skills.reduce((filtered, userSoftSkill) => {
      // Prepare the chipWithLinkData based on the userSoftSkill
      let chipWithLinkData: ChipWithLinkData = {
        variant: userSoftSkill.added_by_id ? "green" : "blue",
        chipLink: {},
        chipData: {
          id: userSoftSkill.soft_skill.id.toString(),
          name: userSoftSkill.soft_skill.name,
        },
        avatar: "",
        chipText: "",
      };

      if (!uniqueSoftSkillIds.has(chipWithLinkData.chipData.id)) {
        // If not, add it to the Set and to the filtered array
        uniqueSoftSkillIds.add(chipWithLinkData.chipData.id);
        filtered.push(chipWithLinkData);
      }

      return filtered;
    }, []);

    softSkills.sort((a, b) => a.variant.localeCompare(b.variant));
    return softSkills;
  }

  get skillsByManagement(): ItemChipsData[] {
    if (!this.userProfile?.skills) {
      return [];
    }
    const skills = this.userProfile.skills.reduce(function (filtered, userSkill) {
      if (userSkill.added_by_id) {
        filtered.push(userSkill.skill);
      }
      return filtered;
    }, []);
    return getSkillsForChips(skills);
  }

  get industries(): ItemChipsData[] {
    if (!this.userProfile?.industries) {
      return [];
    }
    const industries = this.userProfile.industries.reduce(function (
      filtered,
      industry
    ) {
      if (!industry.added_by_id) {
        filtered.push(industry.industry);
      }
      return filtered;
    },
      []);
    return getIndustriesForChips(industries);
  }

  openModal(): void {
    this.showResume = true;
  }

  closeModal(): void {
    this.showResume = false;
  }
  get industries2(): ChipWithLinkData[] {
    if (!this.userProfile?.industries) {
      return [];
    }
    const industries = this.userProfile.industries.reduce(function (
      filtered,
      industry
    ) {
      if (!industry.added_by_id) {
        let chipWithLinkData: ChipWithLinkData = {
          variant: "blue",
          chipLink: {},
          chipData: {
            id: industry.industry.id.toString(),
            name: industry.industry.name,
          },
          avatar: "",
          chipText: "",
        };
        filtered.push(chipWithLinkData);
      } else {
        let chipWithLinkData: ChipWithLinkData = {
          variant: "green",
          chipLink: {},
          chipData: {
            id: industry.industry.id.toString(),
            name: industry.industry.name,
          },
          avatar: "",
          chipText: "",
        };
        filtered.push(chipWithLinkData);
      }
      return filtered;
    },
      []);
    industries.sort((a, b) => a.variant.localeCompare(b.variant));
    return industries;
  }

  get industriesByManagement(): ItemChipsData[] {
    if (!this.userProfile?.industries) {
      return [];
    }
    const industries = this.userProfile.industries.reduce(function (
      filtered,
      industry
    ) {
      if (industry.added_by_id) {
        filtered.push(industry.industry);
      }
      return filtered;
    },
      []);
    return getIndustriesForChips(industries);
  }

  get languages(): ItemChipsData[] {
    if (!this.userProfile?.languages) {
      return [];
    }
    const languages = this.userProfile.languages.reduce(function (
      filtered,
      language
    ) {
      if (!language.added_by_id) {
        filtered.push(language.language);
      }
      return filtered;
    },
      []);
    return getLanguagesForChips(languages);
  }

  get languages2(): ChipWithLinkData[] {
    if (!this.userProfile?.languages) {
      return [];
    }
    const languages = this.userProfile.languages.reduce(function (
      filtered,
      language
    ) {
      if (!language.added_by_id) {
        let chipWithLinkData: ChipWithLinkData = {
          variant: "blue",
          chipLink: {},
          chipData: {
            id: language.language.id.toString(),
            name: language.language.name,
          },
          avatar: "",
          chipText: "",
        };
        filtered.push(chipWithLinkData);
      } else {
        let chipWithLinkData: ChipWithLinkData = {
          variant: "green",
          chipLink: {},
          chipData: {
            id: language.language.id.toString(),
            name: language.language.name,
          },
          avatar: "",
          chipText: "",
        };
        filtered.push(chipWithLinkData);
      }
      return filtered;
    },
      []);
    languages.sort((a, b) => a.variant.localeCompare(b.variant));
    return languages;
  }

  get languagesWithProficiency(): ChipWithLinkData[] {
    if (!this.userProfile?.languages) {
      return [];
    }
    const languages = this.userProfile.languages.reduce(function (
      filtered,
      language
    ) {
      const proficiencyLevel = language.proficiency_level;
      let proficiencyText = "";
      
      switch (proficiencyLevel) {
        case 1:
          proficiencyText = " (Native)";
          break;
        case 2:
          proficiencyText = " (Fluent/Proficient)";
          break;
        case 3:
          proficiencyText = " (Conversational)";
          break;
        case 4:
          proficiencyText = " (Basic)";
          break;
        default:
          proficiencyText = "";
      }
      
      if (!language.added_by_id) {
        let chipWithLinkData: ChipWithLinkData = {
          variant: "blue",
          chipLink: {},
          chipData: {
            id: language.language.id.toString(),
            name: language.language.name + proficiencyText,
          },
          avatar: "",
          chipText: "",
        };
        filtered.push(chipWithLinkData);
      } else {
        let chipWithLinkData: ChipWithLinkData = {
          variant: "green",
          chipLink: {},
          chipData: {
            id: language.language.id.toString(),
            name: language.language.name + proficiencyText,
          },
          avatar: "",
          chipText: "",
        };
        filtered.push(chipWithLinkData);
      }
      return filtered;
    },
      []);
    languages.sort((a, b) => a.variant.localeCompare(b.variant));
    return languages;
  }

  get transportationTypes(): ChipWithLinkData[] {
    if (!this.userProfile?.transportation) {
      return [];
    }
    const transportation = this.userProfile.transportation.map(function (transport) {
      let chipWithLinkData: ChipWithLinkData = {
        variant: "blue",
        chipLink: {},
        chipData: {
          id: transport.id.toString(),
          name: transport.transportation_type == "public_transit" ? "Public Transit" : transport.transportation_type,
        },
        avatar: "",
        chipText: "",
      };
      return chipWithLinkData;
    });
    return transportation;
  }

  get languagesByManagement(): ItemChipsData[] {
    if (!this.userProfile?.languages) {
      return [];
    }
    const languages = this.userProfile.languages.reduce(function (
      filtered,
      language
    ) {
      if (language.added_by_id) {
        filtered.push(language.language);
      }
      return filtered;
    },
      []);
    return getLanguagesForChips(languages);
  }

  get workSamplesByManagement(): ItemChipsData[] {
    const workSamples = [];
    if (this.adminWork) {
      this.adminWork.forEach((work) => {
        workSamples.push(work);
      });
      return workSamples;
    }
    return [];
  }

  get websites(): ItemChipsData[] {
    if (!this.userProfile || !this.userProfile.website) {
      return [];
    }
    var websites = [];
    websites.push({ id: this.contractorId, name: this.userProfile.website });
    return websites;
  }

  get websitesByManagement(): ItemChipsData[] {
    if (!this.userProfile?.website) {
      return [];
    }
    return [{ id: this.contractorId, name: this.userProfile.website }];
  }


  get company(): ItemChipsData[] {
    if (!this.userProfile || !this.userProfile.company_name) {
      return [];
    }
    var company = [];
    company.push({
      id: this.contractorId,
      name: this.userProfile.company_name,
    });
    return company;
  }

  get companyByManagement(): ItemChipsData[] {
    if (!this.userProfile?.company_name) {
      return [];
    }
    return [{
      id: this.contractorId,
      name: this.userProfile.company_name,
    }];
  }

  get jobTitle(): ItemChipsData[] {
    if (!this.userProfile || !this.userProfile.job_title) {
      return [];
    }
    var jobTitle = [];
    jobTitle.push({ id: this.contractorId, name: this.userProfile.job_title });
    return jobTitle;
  }

  get jobTitleByManagement(): ItemChipsData[] {
    if (!this.userProfile?.job_title) {
      return [];
    }
    return [{
      id: this.contractorId,
      name: this.userProfile.job_title,
    }];
  }

  get emailByManagement(): ItemChipsData[] {
    if (!this.userProfile?.email) {
      return [];
    }
    return [{ id: this.contractorId, name: this.userProfile.email }];
  }

  get phoneByManagement(): ItemChipsData[] {
    if (!this.userProfile?.phone) {
      return [];
    }
    return [{ id: this.contractorId, name: this.userProfile.phone }];
  }

  get country(): ItemChipsData[] {
    if (!this.userProfile?.country) {
      return [];
    }
    var country = [];
    country.push({ id: this.contractorId, name: this.userProfile.country });
    return country;
  }

  get countryByManagement(): ItemChipsData[] {
    if (!this.userProfile?.country) {
      return [];
    }
    return [{
      id: this.contractorId,
      name: this.userProfile.country,
    }];
  }

  get city(): ItemChipsData[] {
    if (!this.userProfile?.city) {
      return [];
    }
    var city = [];
    city.push({ id: this.contractorId, name: this.userProfile.city });
    return city;
  }

  get cityByManagement(): ItemChipsData[] {
    if (!this.userProfile?.city) {
      return [];
    }
    return [{ id: this.contractorId, name: this.userProfile.city }];
  }

  get state(): ItemChipsData[] {
    if (!this.userProfile?.state) {
      return [];
    }
    var state = [];
    state.push({ id: this.contractorId, name: this.userProfile.state });
    return state;
  }

  get stateByManagement(): ItemChipsData[] {
    if (!this.userProfile?.state) {
      return [];
    }
    return [{ id: this.contractorId, name: this.userProfile.state }];
  }

  get contractorRates(): ItemChipsData[] {
    if (!this.profile) {
      return [];
    }
    const currency = this.profile?.currency;
    const rateUnit = this.profile?.rate_unit;
    const minRate = this.profile?.min_rate;
    const maxRate = this.profile?.max_rate;

    if (!minRate && !maxRate && !currency && !rateUnit) {
      return [];
    }

    var maximumRates = [];
    let rate = "";
    if (minRate) rate += `$${minRate}`;
    if (minRate && maxRate) rate += ` - $${maxRate}`;
    if (!minRate && maxRate) rate += `$${maxRate}`;
    if (currency) rate += ` ${currency}`;
    if (rateUnit) rate += `/${rateUnit}`;
    if (minRate && maxRate) {
      maximumRates.push({ id: this.contractorId, name: rate });
    }
    return maximumRates;
  }

  get newContractorRates() {
    if (!this.userProfile) {
      return null;
    }
    return `${this.userProfile.min_rate} - ${this.userProfile.max_rate} ${this.userProfile.currency}/${this.userProfile.rate_unit}`;
  }

  get contractorRatesByManagement() {
    if (!this.userProfile) {
      return [];
    }
    const currency = this.userProfile?.currency;
    const rateUnit = this.userProfile?.rate_unit;
    const minRate = this.userProfile?.min_rate;
    const maxRate = this.userProfile?.max_rate;

    if (!minRate && !maxRate && !currency && !rateUnit) {
      return [];
    }

    let rate = "";
    if (minRate) rate += `$${minRate}`;
    if (minRate && maxRate) rate += ` - $${maxRate}`;
    if (!minRate && maxRate) rate += `$${maxRate}`;
    if (currency) rate += ` ${currency}`;
    if (rateUnit) rate += `/${rateUnit}`;
    
    return minRate || maxRate ? [rate] : [];
  }

  get experiencesByManagement(): User_Experience[] {
    if (!this.experiences) {
      return undefined;
    }
    const experiences = this.experiences.reduce(function (
      filtered: User_Experience[],
      experience: User_Experience
    ) {
      if (experience.added_by_id) {
        filtered.push(experience);
      }
      return filtered;
    },
      []);
    return experiences;
  }

  get getWorkCount(): string {
    let length = 0;
    if (this.workSamples !== null) {
      length += this.workSamples?.length;
    }
    if (this.workSamplesByManagement) {
      length += this.workSamplesByManagement?.length;
    }
    return length > 0 ? `(${length})` : "";
  }

  get educationsByManagement(): User_Education[] {
    if (!this.educations) {
      return undefined;
    }
    const educations = this.educations.reduce(function (
      filtered: User_Education[],
      education: User_Education
    ) {
      if (education.added_by_id) {
        filtered.push(education);
      }
      return filtered;
    },
      []);
    return educations;
  }

  get certificationsByManagement(): User_Certification[] {
    if (!this.certifications) {
      return undefined;
    }
    const certifications = this.certifications.reduce(function (
      filtered: User_Certification[],
      certification: User_Certification
    ) {
      if (certification.added_by_id) {
        filtered.push(certification);
      }
      return filtered;
    },
      []);
    return certifications;
  }

  // get industries(): ItemChipsData[] {
  //   const industries = this.profile.industries.map(
  //     (userIndustry) => userIndustry.industry
  //   );
  //   return getIndustriesForChips(industries);
  // }

  // get languages(): ItemChipsData[] {
  //   const languages = this.profile.languages.map(
  //     (userLanguage) => userLanguage.language
  //   );
  //   return getLanguagesForChips(languages);
  // }

  showModal(): void {
    this.$emit("open");
  }

  refreshPage(): void {
    this.$emit("refresh");
  }
  async refetchprofilesByManagement(): Promise<void> {
    this.processing = true;
    await this.$apollo.queries.userProfile.refetch();
    this.processing = false;
  }

  get loading(): boolean {
    if (this.$apollo.queries.userProfile.loading || this.processing) {
      return true;
    }
    return false;
  }
}
